import axios from '@axios'
// import { taxs } from '@sample/tax/taxs.json'

export const state = {
  taxes: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
}

export const getters = {
  allTaxes: (state) => state.taxes,
  currentPage: (state) => state.page,
  totalPages: (state) => state.totalPages,
  perPage: (state) => state.perPage,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_TAXES: (state, respData) => {
    state.taxes = respData.taxes
    if (respData.taxes.length) {
      state.currentPage = respData.page
      state.perPage = respData.perPage
      state.totalPages = respData.totalPages
      state.totalRecords = respData.totalRecords
    }
  },
  CREATE_TAX: (state, tax) => {
    state.taxes.unshift(tax)
  },
  UPDATE_TAX: (state, tax) => {
    state.taxes = state.taxes.filter((ops) => ops.id !== tax.id)
    state.taxes.unshift(tax)
  },
  REMOVE_TAX: (state, tax) => {
    state.taxes = state.taxes.filter((ops) => ops.id !== tax.id)
  },
}

export const actions = {
  async getTaxes({ commit, dispatch }, params = {}) {
    dispatch('layout/changeLoading', true, { root: true })
    await axios
      .get('/sms/taxes', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_TAXES', resp.data)
          dispatch('layout/changeLoading', false, { root: true })
        } else {
          commit('GET_TAXES', { taxes: [] })
          dispatch('layout/changeLoading', false, { root: true })
        }
      })
      .catch(() => {
        commit('GET_TAXES', { taxes: [] })
        dispatch('layout/changeLoading', false, { root: true })
      })
      .finally(() => {
        dispatch('layout/changeLoading', false, { root: true })
      })
  },
  async createTax({ commit }, tax) {
    let form = tax
    await axios.post('/sms/taxes', form).then((resp) => {
      if (resp.status === 201) {
        commit('CREATE_TAX', resp.data)
      }
    })
  },
  async updateTax({ commit }, tax) {
    let form = tax

    await axios.put(`/sms/taxes`, form).then((resp) => {
      if (resp.status === 200) {
        commit('UPDATE_TAX', resp.data)
      }
    })
  },
  async removeTax({ commit, dispatch }, tax) {
    await axios.delete(`/sms/taxes/${tax.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('REMOVE_TAX', tax)
      }
    })
  },
}
